import { TypeSelectOption } from '@thefarmersfront/kitchen';

import { OPTION_ALL } from '~/constants/common';

/**
 * [입고관리] 센터 별 온도대 필터옵션 객체에서, 전체 온도대 필터옵션 배열을 반환하는 함수
 */
export const getAllTemperatureOptions = (groupedTemperature: {
  [key: string]: TypeSelectOption<string>[];
}): TypeSelectOption<string>[] => [
  OPTION_ALL,
  ...Object.values(groupedTemperature)
    .flat()
    .filter(({ value }) => value !== ''),
];

export default getAllTemperatureOptions;
